const languages = {
  en: 1,
  'es-ud': 2,
  es: 3
}

export default languages



// WEBPACK FOOTER //
// ./src/constants/languages.js